import { ref } from "vue";

export const ShowModalDisconnect = ref(false)
export const showModalDisconnectTransition = ref(false)